const page = require('./src/page')

module.exports = {
  page
}



// WEBPACK FOOTER //
// /Users/liranbrimer1/scaleka/exelate/web-commons-export/documents/index.js